import { assert } from "radashi";
import { useParams } from "react-router";

export function useCategoryId() {
  const params = useParams<{ category: string }>();
  assert(params.category, "category could not be found in the route params");
  return params.category;
}
